import { Checkbox, FormControlLabel } from '@mui/material';
import { FunctionComponent } from 'react';
import { useAppDispatch } from '../../store/Hooks';
import { settingsStore, useSettingsSelector } from '../../store/SettingsStore';

export const KeyboardShortcutCheckbox: FunctionComponent = () => {
	const dispatch = useAppDispatch();
	const enabled = useSettingsSelector(settingsStore.selectors.gameControlKeysEnabled);

	function handleChange() {
		dispatch(settingsStore.actions.toggleKeyboardShortcuts());
	}

	return <FormControlLabel
		control={
			<Checkbox checked={enabled} onChange={handleChange} />
		}
		label="Enable keyboard shortcuts for in-game commands"
	/>;
};
